import { useRetryRevision } from 'hooks/queries/layers/revisions/useRetryRevision'
import { Revision } from 'types'
import { Selection } from 'hooks/queries/layers/revisions/useCreateRevision'
import { EditorView } from 'prosemirror-view'
import { selectionFromRevision } from 'components/AIRevision/selectionFromRevision'
import { markdownSerializer } from 'common/Prose/components/TextInlineFormatBar/components/FormatBars/markdownSerializer'
import { Reset } from 'almanac-ui/icons'
import { Tooltip } from 'components/Tooltip/Tooltip'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Button } from 'blaze-components/WriterTopBar/Button'
import { ArrowRotateLeft } from 'blaze-ui/icons/24'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface Props {
  revision: Revision
  view: EditorView
}

export const RetryIconButton = ({ revision, view }: Props) => {
  const { retry, isLoading } = useRetryRevision({ revision })
  const { isMobile } = useResponsiveDesign()

  const handlePress = () => {
    const selection = selectionFromRevision(view.state.doc)

    if (!selection) return

    const doc = view.state.doc
    const documentAsMarkdown = markdownSerializer.serialize(doc)
    const selectionContent = doc.cut(selection.from, selection.to)
    const selectionAsMarkdown = markdownSerializer.serialize(selectionContent)

    return retry({ selection: selection.toJSON() as Selection, selectionAsMarkdown, documentAsMarkdown })
  }

  if (isMobile)
    return (
      <Button icon={ArrowRotateLeft} onPress={handlePress} isDisabled={isLoading}>
        Retry
      </Button>
    )

  return (
    <Tooltip label="Try again">
      <IconButton
        aria-label="Retry"
        icon={Reset}
        size="sm"
        variant="secondary"
        onPress={handlePress}
        isDisabled={isLoading}
      />
    </Tooltip>
  )
}
